export default "__VITE_ASSET__CqTL0auq__"